export default {
  getFirmwareList: {
    method: 'get',
    url: 'firmware'
  },
  reviseFirmware: {
    method: 'put',
    url: 'firmware'
  },
  deleteFirmware: {
    method: 'delete',
    url: 'firmware'
  },
  addFirmware: {
    method: 'post',
    url: 'firmware'
  },
  checkFirmware: {
    method: 'get',
    url: 'firmware/check'
  }
}
